import { FC, ReactElement, Ref } from 'react';

import { ProductDefault } from '../../../../../entities/@products/ProductDefault/ProductDefault';
import { ProductVariant } from '../../../../../entities/@products/ProductVariant/ProductVariant';
import { ProductMediaPresentation } from '../ProductMediaPresentation/ProductMediaPresentation';
import { ProductSidebar } from '../ProductSidebar/ProductSidebar';
import { ProductImagesSkeletons, ProductSidebarSkeletons } from './skeletons';

import './ProductDetail.scss';

interface ProductDetailProps {
    productDefaultIsLoading: boolean;
    cartIsLoading: boolean;
    wishlistIsLoading: boolean;
    hasScrolledPassedCallToActionsButtons: boolean;
    isInWishlist: boolean;
    productDefault?: ProductDefault;
    productVariant?: ProductVariant;
    stockQuantity: number;
    inCartQuantity: number;
    callToActionsRef: Ref<HTMLDivElement>;
    onAddToCart: () => void;
    onWishlistButtonClick: () => void;
    className?: string;
}

export const ProductDetail: FC<ProductDetailProps> = ({
    productDefaultIsLoading,
    cartIsLoading,
    wishlistIsLoading,
    hasScrolledPassedCallToActionsButtons,
    isInWishlist,
    productDefault,
    productVariant,
    stockQuantity,
    inCartQuantity,
    callToActionsRef,
    onAddToCart,
    onWishlistButtonClick,
    className = '',
}): ReactElement => (
    <section className={`product-detail ${className}`}>
        {!productDefault && (
            <ProductImagesSkeletons className="product-detail__media-presentation" />
        )}

        {productDefault && (
            <ProductMediaPresentation
                mediaItems={productDefault.mediaItems}
                className="product-detail__media-presentation"
            />
        )}

        {!productVariant && (
            <ProductSidebarSkeletons className="product-detail__sidebar" />
        )}

        {productVariant && (
            <ProductSidebar
                cartIsLoading={cartIsLoading}
                wishlistIsLoading={wishlistIsLoading}
                variantsAreLoading={productDefaultIsLoading}
                hasScrolledPassedCallToActionsButtons={hasScrolledPassedCallToActionsButtons}
                isInWishlist={isInWishlist}
                productDefault={productDefault}
                productVariant={productVariant}
                inCartQuantity={inCartQuantity}
                stockQuantity={stockQuantity}
                callToActionsRef={callToActionsRef}
                onAddToCart={onAddToCart}
                onWishlistButtonClick={onWishlistButtonClick}
                className="product-detail__sidebar"
            />
        )}
    </section>
);
